/* ============================================================
   UNVEXT — Pre-Order & Waitlist
   IIFE-scoped. No global mutations. Only loaded on pages that
   include sections/preorder-collection.liquid.
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     KLAVIYO CONFIG
     ============================================================
     Replace both placeholders below with the real values from your
     Klaviyo account before going live. The public API key is safe
     to expose in client-side code (it's the Site / Public API Key,
     not the Private API Key).
     ============================================================ */
  var KLAVIYO_PUBLIC_KEY     = 'TA5kgp';
  var KLAVIYO_MASTER_LIST_ID = 'XZ3yjz';
  var KLAVIYO_REVISION       = '2024-10-15';
  var KLAVIYO_ENDPOINT       = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY;

  var SESSION_PREFIX = 'unvxt-wl-submitted-';

  /* ============================================================
     Setup — bail silently if not on the preorder page.
     ============================================================ */
  var drawer = document.getElementById('unvxt-wl-drawer');
  if (!drawer) return;

  var refs = {
    image:        drawer.querySelector('[data-unvxt-wl-image]'),
    title:        drawer.querySelector('[data-unvxt-wl-title]'),
    form:         drawer.querySelector('[data-unvxt-wl-form]'),
    submit:       drawer.querySelector('[data-unvxt-wl-submit]'),
    error:        drawer.querySelector('[data-unvxt-wl-error]'),
    success:      drawer.querySelector('[data-unvxt-wl-success]'),
    successEmail: drawer.querySelector('[data-unvxt-wl-success-email]'),
    closers:      drawer.querySelectorAll('[data-unvxt-wl-close]')
  };

  var activeListId = null;
  var activeHandle = null;
  var bodyScrollLockY = 0;

  /* ============================================================
     SessionStorage helpers — duplicate-submit prevention
     ============================================================ */
  function alreadySubmitted(handle) {
    try { return sessionStorage.getItem(SESSION_PREFIX + handle) === '1'; }
    catch (e) { return false; }
  }
  function markSubmitted(handle) {
    try { sessionStorage.setItem(SESSION_PREFIX + handle, '1'); } catch (e) {}
  }
  function disableJoinButtonsForHandle(handle) {
    var btns = document.querySelectorAll('[data-unvxt-wl-join][data-product-handle="' + handle + '"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].disabled = true;
      btns[i].textContent = "You're on the list";
      btns[i].classList.add('unvxt-wl-card__cta--joined');
    }
  }

  /* ============================================================
     Drawer open / close
     ============================================================ */
  function lockBodyScroll() {
    bodyScrollLockY = window.scrollY || 0;
    document.body.style.overflow = 'hidden';
  }
  function unlockBodyScroll() {
    document.body.style.overflow = '';
  }

  function resetForm() {
    if (refs.form) refs.form.reset();
    if (refs.error) { refs.error.hidden = true; refs.error.textContent = ''; }
    if (refs.submit) { refs.submit.disabled = false; refs.submit.textContent = 'Notify Me'; }
    if (refs.form) refs.form.hidden = false;
    if (refs.success) refs.success.hidden = true;
  }

  function openDrawer(product) {
    activeListId = product.listId || null;
    activeHandle = product.handle || null;

    if (refs.title) refs.title.textContent = product.title || '';
    if (refs.image) {
      if (product.image) {
        refs.image.src = product.image;
        refs.image.alt = product.title || '';
        refs.image.style.display = '';
      } else {
        refs.image.removeAttribute('src');
        refs.image.style.display = 'none';
      }
    }
    resetForm();
    drawer.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
    activeListId = null;
    activeHandle = null;
    // Defer reset slightly so the drawer doesn't visually flash during the close animation
    setTimeout(resetForm, 280);
  }

  /* ============================================================
     UI state changes
     ============================================================ */
  function showError(message) {
    if (!refs.error) return;
    refs.error.textContent = message || 'Something went wrong. Please try again.';
    refs.error.hidden = false;
  }
  function showSuccess(email) {
    if (refs.form) refs.form.hidden = true;
    if (refs.successEmail) refs.successEmail.textContent = email || 'you';
    if (refs.success) refs.success.hidden = false;
  }

  /* ============================================================
     Klaviyo Client API — subscribe an email to a list
     Returns a promise. Throws on non-2xx responses.
     ============================================================ */
  function subscribeToKlaviyo(listId, email, productHandle, size, label) {
    // Sanitize the property key: Klaviyo property keys are most reliable with underscores only
    var safeHandle = String(productHandle || '').replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    var propertyKey = 'waitlist_' + safeHandle + '_size';
    var properties = {};
    properties[propertyKey] = size;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Unvext Waitlist',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    if (window.console && console.log) {
      console.log('[unvxt-wl] ' + label + ' REQUEST →', KLAVIYO_ENDPOINT);
      console.log('[unvxt-wl] ' + label + ' BODY:', JSON.stringify(body, null, 2));
    }

    return fetch(KLAVIYO_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.ok || response.status === 202) {
        if (window.console && console.log) console.log('[unvxt-wl] ' + label + ' OK (HTTP ' + response.status + ', list: ' + listId + ')');
        return true;
      }
      return response.text().then(function (text) {
        if (window.console && console.error) {
          console.error('[unvxt-wl] ' + label + ' RESPONSE HTTP ' + response.status);
          console.error('[unvxt-wl] ' + label + ' RESPONSE BODY:', text);
        }
        var detail = text;
        try { var parsed = JSON.parse(text); if (parsed && parsed.errors) detail = JSON.stringify(parsed.errors); } catch (e) {}
        var err = new Error(label + ' failed (HTTP ' + response.status + '): ' + detail);
        err.status = response.status;
        err.label = label;
        err.listId = listId;
        err.detail = detail;
        throw err;
      });
    });
  }

  /* ============================================================
     Form submit handler
     ============================================================ */
  if (refs.form) {
    refs.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(refs.form);
      var email = (formData.get('email') || '').toString().trim();
      var size  = (formData.get('size') || '').toString();

      if (!email) { showError('Please enter your email.'); return; }
      if (!size)  { showError('Please choose a size.'); return; }
      if (!activeListId) {
        showError('This product is not configured yet. Please try again later.');
        return;
      }

      if (refs.submit) {
        refs.submit.disabled = true;
        refs.submit.textContent = 'Submitting…';
      }
      if (refs.error) refs.error.hidden = true;

      // Fire both subscriptions in parallel, treat them independently.
      // Product-specific list is required for "success" UX.
      // Master newsletter list is best-effort — its failure is logged but doesn't block.
      var productCall = subscribeToKlaviyo(activeListId, email, activeHandle, size, 'product-list');
      var masterCall = KLAVIYO_MASTER_LIST_ID && KLAVIYO_MASTER_LIST_ID.indexOf('__REPLACE') !== 0
        ? subscribeToKlaviyo(KLAVIYO_MASTER_LIST_ID, email, activeHandle, size, 'master-list')
            .catch(function (err) {
              if (window.console && console.warn) console.warn('[unvxt-wl] master-list error (non-blocking):', err.message || err);
              return null;
            })
        : Promise.resolve(null);

      productCall
        .then(function () {
          return masterCall;
        })
        .then(function () {
          markSubmitted(activeHandle);
          disableJoinButtonsForHandle(activeHandle);
          showSuccess(email);
        })
        .catch(function (err) {
          if (refs.submit) {
            refs.submit.disabled = false;
            refs.submit.textContent = 'Notify Me';
          }
          // Show the actual status to help debugging
          var msg = 'Something went wrong. Please try again.';
          if (err && err.detail) msg = 'Klaviyo ' + err.status + ': ' + err.detail.substring(0, 280);
          else if (err && err.status === 400) msg = 'Klaviyo rejected list ID "' + (activeListId || '(empty)') + '". Verify this product\'s Klaviyo list ID metafield.';
          else if (err && err.status === 401) msg = 'Klaviyo authentication failed. Check the public API key.';
          else if (err && err.status === 404) msg = 'Klaviyo list not found. Check the list ID in this product\'s metafield.';
          else if (err && err.status === 429) msg = 'Too many requests. Try again in a moment.';
          else if (err && err.status) msg = 'Klaviyo error ' + err.status + '. Open the browser console for detail.';
          showError(msg);
          if (window.console && console.error) console.error('[unvxt-wl] product-list error:', err);
        });
    });
  }

  /* ============================================================
     Event wiring
     ============================================================ */
  // Open: delegated click on any Join Waitlist button
  document.addEventListener('click', function (e) {
    var joinBtn = e.target.closest && e.target.closest('[data-unvxt-wl-join]');
    if (!joinBtn) return;
    e.preventDefault();
    if (joinBtn.disabled) return;
    openDrawer({
      listId: joinBtn.getAttribute('data-list-id'),
      handle: joinBtn.getAttribute('data-product-handle'),
      title:  joinBtn.getAttribute('data-product-title'),
      image:  joinBtn.getAttribute('data-product-image')
    });
  });

  // Close: all elements marked data-unvxt-wl-close
  for (var i = 0; i < refs.closers.length; i++) {
    refs.closers[i].addEventListener('click', closeDrawer);
  }

  // Close: Esc key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  /* ============================================================
     Filter bar — client-side, no reload
     ============================================================ */
  var filterBtns = document.querySelectorAll('[data-unvxt-wl-filter]');
  if (filterBtns.length > 0) {
    for (var f = 0; f < filterBtns.length; f++) {
      filterBtns[f].addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var filter = btn.getAttribute('data-unvxt-wl-filter');
        for (var b = 0; b < filterBtns.length; b++) {
          filterBtns[b].classList.toggle('is-active', filterBtns[b] === btn);
        }
        var cards = document.querySelectorAll('.unvxt-wl-card');
        for (var c = 0; c < cards.length; c++) {
          var state = cards[c].getAttribute('data-unvxt-wl-state');
          var show = (filter === 'all' || state === filter);
          cards[c].hidden = !show;
        }
      });
    }
  }

  /* ============================================================
     Page-load session lock
     Disable Join Waitlist buttons whose product was submitted this session.
     ============================================================ */
  var joinButtons = document.querySelectorAll('[data-unvxt-wl-join]');
  for (var j = 0; j < joinButtons.length; j++) {
    var handle = joinButtons[j].getAttribute('data-product-handle');
    if (handle && alreadySubmitted(handle)) {
      disableJoinButtonsForHandle(handle);
    }
  }
})();
